import { render, staticRenderFns } from "./targetcollectionfull.vue?vue&type=template&id=6a9fc2f8&scoped=true"
import script from "./targetcollectionfull.vue?vue&type=script&lang=js"
export * from "./targetcollectionfull.vue?vue&type=script&lang=js"
import style0 from "./targetcollectionfull.vue?vue&type=style&index=0&id=6a9fc2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9fc2f8",
  null
  
)

export default component.exports